import * as R from 'ramda'
import i18n from '@/locales'

export const getAccessUrlTableColumn = () => {
  return {
    field: 'cloudaccount_detail.access_url',
    title: i18n.t('scope.text_543'),
    minWidth: 100,
    showOverflow: 'ellipsis',
    slots: {
      default: ({ row }, h) => {
        if (!row.cloudaccount_detail || !row.cloudaccount_detail.access_url) return '-'
        let txt
        Object.keys(i18n.t('cloudAccountAccessType')).forEach(k => {
          if (row.cloudaccount_detail.access_url.indexOf(k) > -1) {
            txt = i18n.t('cloudAccountAccessType')[k]
          }
        })
        return txt ||
        [
          <a class="link-color" target="_blank" href={ row.cloudaccount_detail.access_url }>{ row.cloudaccount_detail.access_url }</a>,
        ]
      },
    },
  }
}

export const getBalanceTableColumn = () => {
  return {
    field: 'cloudaccount_detail.balance',
    title: i18n.t('scope.text_577'),
    minWidth: 70,
    showOverflow: 'ellipsis',
    formatter: ({ row }) => {
      if (!row.cloudaccount_detail) return '-'
      if (R.isNil(row.cloudaccount_detail.balance)) {
        return '-'
      }
      return row.cloudaccount_detail.balance
    },
  }
}

export const getGuestCountTableColumn = () => {
  return {
    field: 'cloudaccount_detail.guest_count',
    title: i18n.t('scope.text_578'),
    width: 60,
  }
}

export const getHostCountTableColumn = () => {
  return {
    field: 'cloudaccount_detail.host_count',
    title: i18n.t('scope.text_579'),
    minWidth: 70,
  }
}

export const getPublicScopeTableColumn = () => {
  return {
    field: 'public_scope',
    title: i18n.t('scope.text_580'),
    width: 110,
    showOverflow: 'title',
    formatter: ({ row }) => {
      if (!row.is_public) return i18n.t('cloudAccountShareDesc.none')
      const { share_mode: shareMode, public_scope: publicScope, shared_domains: sharedDomains } = row
      if (publicScope === 'domain') {
        if (shareMode === 'provider_domain' && sharedDomains && sharedDomains.length > 0) {
          return i18n.t('cloudAccountShareDesc.provider')
        }
        if (shareMode === 'system' && sharedDomains && sharedDomains.length > 0) {
          return i18n.t('cloudAccountShareDesc.account')
        }
      }
      if (publicScope === 'system') {
        if (shareMode === 'provider_domain') {
          return i18n.t('cloudAccountShareDesc.providerAll')
        }
        if (shareMode === 'system' && sharedDomains && sharedDomains.length > 0) {
          return i18n.t('cloudAccountShareDesc.accountAll')
        }
      }
      return '-'
    },
  }
}
